export default __webpack_public_path__ + "static/3898fc2f-b3f8-4656-a283-bdcbf137ffbb-cb17e1aaaca38e1879161ef7af114374.woff2";